var scope_0 = require('/builds/jj7DZkcz/1/miui_security_fe/iot-privacy-white-paper-global/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0 )
    